import type { Route } from '~/core/router'

import { NotificationToasts } from '~/entities/notification-toasts'
import * as content from './content'
import * as modules from './modules'
import * as old2new from './old2new-redirects'
import * as service from './service'

// top-level routes
export const route: Route = {
  path: '',

  component: [NotificationToasts],

  children: [
    ...service.before,
    ...old2new.before,

    // content canonical routes,
    // always stable, regardless of enabled modules
    {
      path: '/content',
      load: content.route,
    },

    // modules dynamic routes,
    // could be enabled/disabled/renamed in nora
    {
      path: '/modules',
      load: modules.route,
    },

    // service application routes
    {
      path: '',
      load: service.route,
    },

    ...service.after,
  ],
}
